import React from 'react';
import {connect} from 'react-redux';
import config from '../config/';
import Text, {TranslatedInput, Option} from './Text';
import queryString from 'query-string';
import { setAddress } from '../actions';

const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const dayOptions = days.map(day => <Option key={day} value={day} id={`days.full.${day}`}/>);
const now = new Date();
const roundTime = time => {
  const parts = time.split(':');
  let hours = parseInt(parts[0], 10);
  let minutes = Math.ceil(parseInt(parts[1], 10) / 15) * 15;

  if (minutes == 60) {
    hours++;
    minutes = '00';

    if (hours == 24) {
      hours = 0;
    }
  }

  return `${hours}:${minutes}`;
};

class WidgetSearchContainer extends React.Component {
  constructor (props) {
    super(props);

    const date = new Date();

    this.placesDetailsLAT = null;
    this.placesDetailsLNG = null;

    this.state = {
      showOptions: props.expandOptions || props.search.filter.boxes || props.search.filter.luggage || props.search.filter.time,
      showTimeFilter: props.search.filter.time,
      defaultDate: props.search.filter.time.time || roundTime(`${date.getHours()}:${date.getMinutes()}`),
      useAutocomplete: true
    };
  }

  onInputChangeHandler() {
    const {dispatch, config} = this.props;
    const placesOptions = {
      componentRestrictions: {
        country: config.country
      },
      fields: ['name', 'geometry.location', 'place_id', 'formatted_address']
    };

    // ADD AUTOCOMPLETE
    // NOTE: In order to get autocomplete with the *third* character, we have to
    // initialize it after the the second has been typed. Autocomplete only
    // triggers when a key has been pressed - hence with the third it has to be
    // in place already.
    const charCount = 1;

    //! false - disables autocomplete "PlaceService Google API call"
    if (false && this.input.value.length >= charCount && !this.autocomplete) {

       /*
       Start of: "don't make PlaceService Google API call for the second time if input doesn't change"
       - reset if input changes
       - it will be re-defined if user selects autocomplete ("PlaceService Google API call")
       - if input changes and autocomplete isn't used, it will stay null and trigger PlaceService Google API call
       */
       this.placesDetailsLAT = null;
       this.placesDetailsLNG = null;
       //End-of

       this.autocomplete = new google.maps.places.Autocomplete(this.input, placesOptions);
       this.autocompleteListener = google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
        // get lat/lng via autocomplete (via PlaceService Google API call ) when user selects the address from autocomplete menu
        const autocompletePlacesDetails = this.autocomplete.getPlace();

        // store lat/lng of the address from autocomplete "PlaceService Google API call"
        if (autocompletePlacesDetails.geometry.location) {
            this.placesDetailsLAT = autocompletePlacesDetails.geometry.location.lat();
            this.placesDetailsLNG = autocompletePlacesDetails.geometry.location.lng();
        }
        this.handlePlaceChanged.bind(this);
      });
    }

    // REMOVE AUTOCOMPLETE
    //! false - disables autocomplete "PlaceService Google API call"
    else if (false && this.input.value.length < charCount && this.autocomplete) {
      const pacContainer = document.querySelector('.pac-container')

      google.maps.event.removeListener(this.autocompleteListener);
      google.maps.event.clearInstanceListeners(this.autocomplete);
      google.maps.event.clearInstanceListeners(this.input);
      this.autocomplete = false;
      this.autocompletListener = undefined;

      if (pacContainer) {
        pacContainer.parentNode.removeChild(pacContainer);
      }
    }

    dispatch(setAddress(this.input.value, false))
  }

  handlePlaceChanged() {
    this.props.dispatch(setAddress(this.input.value, false, this.placesDetailsLAT, this.placesDetailsLNG));

    google.maps.event.clearInstanceListeners(this.input);

  }

  toggleOptions() {
    this.setOptions(!this.state.showOptions);
  }

  setOptions(showOptions) {
    this.setState(Object.assign({}, this.state, { showOptions }));
  }

  render () {
    const {search, country} = this.props;
    const {filter} = search;

    let luggageFilter;
    let boxesFilter;
    let daySelect;
    let hourInput;
    let openOnCheckbox;

    const disableLuggage = config.countryOptions[country].disableLuggage;
    const disableBoxes = config.countryOptions[country].disableBoxes;
    const disableTime = config.countryOptions[country].disableTime;

    return (
      <form className='widget-search-container' onSubmit={e => {
        e.preventDefault();
        const query = queryString.parse(location.search);
        const urlBuilder = document.createElement('a');

        urlBuilder.href = 'hpsf.html';
        urlBuilder.search = queryString.stringify(Object.assign({}, query, {
          acceptsSuitcases: luggageFilter && luggageFilter.checked ? 'on' : undefined,
          package: boxesFilter && boxesFilter.checked ? 'on' : undefined,
          city: this.input.value ? this.input.value : undefined,
          open: openOnCheckbox.checked ? 'on' : undefined,
          weekday: openOnCheckbox && daySelect.value ? days.indexOf(daySelect.value) + 1 : undefined,
          time: openOnCheckbox && hourInput.value ? hourInput.value : undefined
        }));

        window.open(urlBuilder.href);
      }}>

      <TranslatedInput
        type='text'
        className='mb-sm'
        placeholderId='widget.input-placeholder'
        setRef={n => this.input = n}
        onChange={this.onInputChangeHandler.bind(this)}
      />

      <div className="mb-sm" style={{
          display: this.state.showOptions ? 'block' : 'none'
        }}>
          {disableLuggage ? null : (
            <div className="form-check">
              <label className="form-check-label">
                <input className="form-check-input fs-6" type="checkbox" ref={n => luggageFilter = n} defaultChecked={filter.luggage}/>
                <Text id="search-detail.luggage.label"/>
              </label>
            </div>
          )}

          {disableBoxes ? null : (
            <div className="form-check">
              <label className="form-check-label">
                <input className="form-check-input fs-6" type="checkbox" ref={n => boxesFilter = n} defaultChecked={filter.boxes}/>
                <Text id="search-detail.boxes.label"/>
              </label>
            </div>
          )}

          {disableTime ? null : (
            <div className="form-check more-options">
              <label className="form-check-label">
                <input className="form-check-input fs-6" type="checkbox" ref={n => openOnCheckbox = n} defaultChecked={this.state.showTimeFilter} onChange={e => {
                this.setState(Object.assign({}, this.state, {
                  showTimeFilter: e.target.checked
                }));
              }}/>
                <Text id="widget.open-on" />
              </label>

              <div style={{ display: this.state.showTimeFilter ? 'block' : 'none' }}>
                <select defaultValue={days[now.getDay() - 1]} className="form-control form-control-sm mt-sm" ref={n => daySelect = n}>
                  {dayOptions}
                </select>
                <input type='time' defaultValue={this.state.defaultDate} ref={n => hourInput = n} className='form-control form-control-sm'/>
              </div>
            </div>
          )}
        </div>

        <button className='btn btn-link' onClick={e => {e.preventDefault(); this.toggleOptions();}} type='button'>
          <span className={`halflings halflings-chevron-${this.state.showOptions ? 'up' : 'down'}`} ></span>
          {' '} <Text id="widget.option-button"/>
        </button>

        <button className="btn btn-primary" type='submit'>
          <Text id="widget.submit-button"/>
        </button>
      </form>
    );
  }
}

const mapStateToProps = ({search, config}/*, ownprops */) => ({
  search,
  config,
  country: config.country,
  expandOptions: !!config.options
});

export default connect(mapStateToProps)(WidgetSearchContainer);
